<mat-drawer-container class="sidenav-container">
  <mat-drawer
    class="sidenav"
    [mode]="isSmallScreen() ? 'over' : 'side'"
              [opened]="isOpen()">
    <app-project-side-nav [isMobile]="isSmallScreen()"></app-project-side-nav>
  </mat-drawer>

  <mat-drawer-content
    id="scroll-container"
    [ngClass]="isSmallScreen() ? 'content-mobile' : 'content'"
    [class.content--width-fallback]="!isOpen() && !isSmallScreen()"
  >
    <div [@routeAnimations]="prepareRoute(outlet)">
      <router-outlet #outlet="outlet"></router-outlet>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
